import { MessageCircle } from "lucide-react";
import {
  CoachingNudgeParamsSchema,
  defaultCoachingNudgeParams,
  type CoachingNudgeParams,
} from "@playbookai/widget-schemas";
import { registerWidget } from "../registry.js";
import type { SqlWidgetDef } from "../types.js";
import { CoachingNudgeWidget } from "./Component.js";

/**
 * Coaching Nudge — AI dashboard widget (AI, medium). A short, personal Player
 * AI nudge with an "ask about this" follow-up. Content is MOCKED today and
 * rides the saved params; the AIS swap is drop-in (ADR-0012 / 0007). Self-
 * contained: `TView` defaults to `TParams` (`CoachingNudgeParams`). No per-
 * instance editor. The canvas-only `SqlWidgetDef` fields are neutral filler —
 * this kind is dashboard-only (`modes: ["dashboard"]`).
 */
export const coachingNudgeDef: SqlWidgetDef<CoachingNudgeParams> = {
  kind: "coachingNudge",
  label: "Coaching Nudge",
  modes: ["dashboard"],
  singleton: true,
  defaultSize: { w: 352, h: 120 },
  defaultParams: defaultCoachingNudgeParams,
  Component: CoachingNudgeWidget,
  storage: "sql",
  schema: CoachingNudgeParamsSchema,
  accent: "purple",
  icon: MessageCircle,
  subtitle: "Short personal PlayerAI nudges",
  defaultRoster: false,
  category: "single",
  layout: { col: 1, row: 1, width: 352, height: 120 },
  dashboard: {
    icon: MessageCircle,
    defaultWidth: "medium",
    category: "AI",
  },
};

registerWidget(coachingNudgeDef);
